import { call, put, takeLatest } from "redux-saga/effects";
import { GET_BOOKING_AL, GET_PATIENTS_DETAILS, UPDATE_BOOKING, UPLOAD_PATIENT_INSURANCE, UPLOAD_PATIENT_REPORT } from "../Constants";
import store from "../store"
import api from "../utils/apiRoutes"
import Cookies from "js-cookie";
import { getBookingALRet, upload_patient_insurance_ret, upload_patient_report_ret ,updateBookingRet} from "../actions/bookingActions";

function* getBookingALSaga() {
    const  data = yield store.getState().bookingStore.getBookingAL
    const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get("token_medical_auth")}` } }
    try {         
        const apiData = yield call(api.booking.getProfessionalBookings, data, headers)
        if(apiData.success) {
            yield put(getBookingALRet({
                success: true,
                data: apiData.data,
                count: apiData.count,
                size: apiData.size,
                message: apiData.message || "Data fetched Successful",
            }))
        }
        else {
            yield put(getBookingALRet({
                success: false,
                message: "Invalid Request"
            }))
            // yield put(loginError())
        }

    } catch (error) {
        yield put(getBookingALRet({
            success: false,
            message: "Invalid Request"
        }))
        // yield put(loginError())
    }
}



function* upload_patient_report_saga() {
    try {
        const  data  = yield store.getState().bookingStore.upload_patient_report
        const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get('token_medical_auth') }`, "Content-Type": "multipart/form-data"} }
        const api_data = yield call(api.booking.uploadReport, data, headers)
        if(!!api_data){
          if (api_data.status === 200) {
              yield put(upload_patient_report_ret({
                  success:true,
                  message:'Image uploaded successfully',
                  data:api_data.data.data
                }))
            }else{
              yield put(upload_patient_report_ret({
                  success:false,
                  message:'Something went wrong try again later..',
                  data:[]
                }))
            }
        }
    } catch (e) {
    //   console.log(e,"e in get_act insigt saga")
      try{
          yield put(upload_patient_report_ret({
              success:false,
              message:'Something went wrong try again later..',
              data:[]
            }))
        }catch(x){
          yield put(upload_patient_report_ret({
              success:false,
              message:'Something went wrong try again later..',
              data:[]
            }))
          }
    }
}


function* upload_patient_insurance_saga() {
    try {
        const  data  = yield store.getState().bookingStore.upload_patient_insurance
        const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get('token_medical_auth') }`, "Content-Type": "multipart/form-data"} }
        const api_data = yield call(api.booking.uploadInsurance, data, headers)
        if(!!api_data){
          if (api_data.status === 200) {
              yield put(upload_patient_insurance_ret({
                  success:true,
                  message:'Image uploaded successfully',
                  data:api_data.data.data
                }))
            }else{
              yield put(upload_patient_insurance_ret({
                  success:false,
                  message:'Something went wrong try again later..',
                  data:[]
                }))
            }
        }
    } catch (e) {
    //   console.log(e,"e in get_act insigt saga")
      try{
          yield put(upload_patient_insurance_ret({
              success:false,
              message:'Something went wrong try again later..',
              data:[]
            }))
        }catch(x){
          yield put(upload_patient_insurance_ret({
              success:false,
              message:'Something went wrong try again later..',
              data:[]
            }))
          }
    }
}

function* updateBookingSaga() {
    const  data = yield store.getState().bookingStore.updateBooking
    // console.log({data})
    const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get("token_medical_auth")}` } }
    try {         
        const apiData = yield call(api.booking.updateBooking, data, headers)
        // console.log({apiData});
        if(apiData.success) {
            yield put(updateBookingRet({
                success: true,
                data: apiData.data,
                message: apiData.message || "Data fetched Successful",
            }))
        }
        else {
            yield put(updateBookingRet({
                success: false,
                message: "Invalid Request"
            }))
            // yield put(loginError())
        }

    } catch (error) {
        yield put(updateBookingRet({
            success: false,
            message: "Invalid Request"
        }))
        // yield put(loginError())
    }
}

export const authSaga = [
    takeLatest(GET_BOOKING_AL, getBookingALSaga),
    takeLatest(UPLOAD_PATIENT_REPORT, upload_patient_report_saga),
    takeLatest(UPLOAD_PATIENT_INSURANCE, upload_patient_insurance_saga),
    takeLatest(UPDATE_BOOKING, updateBookingSaga)
]

export default authSaga